import { Component, Input, Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {
	transformString(value: string, indexes) {
		if (!indexes) {
			return;
		}

		let words = indexes.map((element) => {
			return value.substring(element[0], element[1] + 1);
		});

		words = [...new Set(words)];

		words.forEach((word) => {
			if (word.length > 3) {
				const regex = new RegExp(word, 'g');
				value = value.replace(regex, `<span class="highlight">${word}</span>`);
			}
		});

		return value.replace(/(?:\r\n|\r|\n)/g, '<br>');
	}
	transform(value, indexes) {
		if (value && indexes) {
			value = decodeURIComponent(value);
			const newText: string = this.transformString(value, indexes);
			return newText;
		} else {
			return value;
		}
	}
}

@Component({
	selector: 'vc-history-card',
	templateUrl: './vc-history-card.component.html',
	styleUrls: ['./vc-history-card.component.scss'],
})
export class VCHistoryCardComponent {
	@Input() date: string;
	@Input() note: string;
	@Input() highlightIndexes = [];

	public isOpen = false;

	formatDate(date) {
		return DateTime.fromISO(date).toFormat('dd/MM/yyyy');
	}
}
